import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import { FilterChip, Box } from 'pcln-design-system'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { setCurrentMobileFilter } from '../../actions'
import { RoutingHelper } from '../../util/routingHelper'
import { FilterBarTabs } from './FilterChip.styles'
import { toggleChipsHighlight } from './helpers'
import { keyCodes, keys } from '../../../common/constants/keyBoardKeys'
import { pclnExpt } from '../../../common/fly-experimentation/fly-experimentation'
class FilterChipsMobile extends React.Component {
  static propTypes = {
    filterInfo: PropTypes.object.isRequired,
    timeFilter: PropTypes.array.isRequired,
    setCurrentMobileFilter: PropTypes.func.isRequired,
    currentMobileFilter: PropTypes.string,
    hasAltDates: PropTypes.bool,
    pclnBootstrapData: PropTypes.object,
    altDatesFilter: PropTypes.array,
  }

  /** DO NOT MAKE STATE UPDATES IN THIS COMPONENT OUTSIDE OF THIS METHOD */
  static getDerivedStateFromProps(props, state) {
    const {
      timeFilter,
      filterInfo: { defaults, values, originalValues: ogValues },
    } = props

    if (!defaults) {
      return state
    }

    // For one way searches, isSlice1 is always true and property keys
    // aren't appended with a number like with round trip (ex: selectedStops vs selectedStops1)
    const isSlice1 = defaults.TIME[0].sliceRefId === 1
    const isRT = props.pclnBootstrapData?.isRoundTrip
    const selectedStopsProperty = isRT ? 'selectedStops1' : 'selectedStops'
    const excludeCarriersProperty = isRT
      ? 'excludedCarriers1'
      : 'excludedCarriers'

    const includeCarriersProperty = isRT
      ? 'includedCarriers1'
      : 'includedCarriers'

    // Stops filter flag (BUGFIX AIR-35444)
    let isStopsApplied = toggleChipsHighlight(
      ogValues,
      values,
      isSlice1,
      'STOPS',
      selectedStopsProperty,
      null,
      null
    )

    // Airlines filter flag (BUGFIX AIR-35444)
    let isAirlinesApplied = toggleChipsHighlight(
      ogValues,
      values,
      isSlice1,
      'AIRLINES',
      null,
      excludeCarriersProperty,
      includeCarriersProperty
    )

    return {
      stopsApplied: isStopsApplied,
      airlinesApplied: isAirlinesApplied,
      timeApplied: !isEqual(defaults.DEFAULT_TIME, timeFilter),
      datesApplied: !!values.excludedDates?.length,
      airportsApplied: defaults.TIME.some(({ sliceRefId }) => {
        const originKey = 'origAirports' + sliceRefId
        const destKey = 'destAirports' + sliceRefId

        return (
          (values[originKey]?.length !== ogValues[originKey]?.length &&
            values[originKey]?.length !== 0) ||
          (values[destKey]?.length !== ogValues[destKey]?.length &&
            values[destKey]?.length !== 0)
        )
      }),
    }
  }

  state = {
    stopsApplied: false,
    airlinesApplied: false,
    timeApplied: false,
    datesApplied: false,
    airportsApplied: false,
  }

  componentDidMount() {
    this.routingHelper = new RoutingHelper()
  }

  handleFilterClick = tabName => e => {
    if (
      e.key === keys.enter ||
      e.keyCode === keyCodes.enter ||
      e.key === keys.space ||
      e.keyCode === keyCodes.space ||
      e.type === 'click' ||
      e.type === 'change'
    ) {
      this.props.setCurrentMobileFilter(tabName)
      this.routingHelper.goToFilters()
    }
  }

  render() {
    if (!get(this.props, 'filterInfo.defaults', null)) {
      return null
    }
    const {
      stopsApplied,
      airlinesApplied,
      airportsApplied,
      datesApplied,
      timeApplied,
    } = this.state

    const { altDatesFilter, hasAltDates, pclnBootstrapData } = this.props
    const isReshopExperience = pclnBootstrapData?.isReshopExperience

    const isMultiDestination = get(
      this,
      'props.pclnBootstrapData.isMultiDestination',
      false
    )
    return (
      <Box
        m={'16px 0px 0px'}
        pl={'8px'}
        width={1}
        data-test-id='filter-bar-container'
        color='background.lightest'
      >
        <FilterBarTabs data-test-id='filter-bar-tabs'>
          <FilterChip
            role='button'
            tabIndex='0'
            mx={1}
            key='stops'
            title='stops'
            label='Stops'
            onClick={this.handleFilterClick('stops')}
            onKeyDown={this.handleFilterClick('stops')}
            align={'center'}
            selected={stopsApplied}
            size='md'
          />
          {hasAltDates && altDatesFilter?.length && !isMultiDestination ? (
            <FilterChip
              role='button'
              tabIndex='0'
              mx={1}
              key='dates'
              title='dates'
              label='Dates'
              onClick={this.handleFilterClick('dates')}
              onKeyDown={this.handleFilterClick('dates')}
              align={'center'}
              selected={datesApplied}
              size='md'
            />
          ) : null}
          <FilterChip
            role='button'
            mx={1}
            tabIndex='0'
            key='time'
            title='time'
            label='Times'
            onClick={this.handleFilterClick('time')}
            onKeyDown={this.handleFilterClick('time')}
            selected={timeApplied}
            size='md'
          />
          {!isReshopExperience && (
            <FilterChip
              role='button'
              tabIndex='0'
              mx={1}
              key='airlines'
              title='airlines'
              label='Airlines'
              onClick={this.handleFilterClick('airlines')}
              onKeyDown={this.handleFilterClick('airlines')}
              selected={airlinesApplied}
              size='md'
            />
          )}
          {!isMultiDestination ||
          (isMultiDestination &&
            pclnExpt.isVariant('AIR_LISTINGS_MD_AIRPORT_FILTERS')) ? (
            <FilterChip
              role='button'
              label='Airports'
              tabIndex='0'
              mx={1}
              key='airports'
              title='airports'
              onClick={this.handleFilterClick('airports')}
              onKeyDown={this.handleFilterClick('airports')}
              selected={airportsApplied}
              size='md'
            />
          ) : null}
        </FilterBarTabs>
      </Box>
    )
  }
}

const mapStateToProps = state => ({
  pclnBootstrapData: get(state, 'pclnBootstrapData', {}),
  filterInfo: get(state, 'filterInfo') || {},
  timeFilter: state.timeFilter || [],
  currentMobileFilter: get(state, 'uiToggles.currentMobileFilter', ''),
  hasAltDates: get(state, 'filterInfo.hasAltDates', false),
  altDatesFilter: state.altDatesFilter,
})

const filterChipsMobile = connect(mapStateToProps, { setCurrentMobileFilter })(
  FilterChipsMobile
)

export { filterChipsMobile as FilterChipsMobile }
